module.exports = __webpack_public_path__ + "static/media/bufficorn.239224ff.jpg";